export class PAYMENT_SOURCE {
    static readonly Insurance: string = '00000092-1000-0000-0000-000000000001';
    static readonly Patient: string = '00000092-1000-0000-0000-000000000002';
    static readonly ApplyCredit: string = '00000092-1000-0000-0000-000000000006';
}